import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { sparseSegmentSchema } from "../shared/sparseSegmentSchema";
import { audienceDescriptionHashSchema } from "../shared/audienceDescriptionHashSchema";
import { filtersGetSchema, exclusionFiltersGetSchema } from "../filter/filtersGetSchema";

export const audiencePathGetSchema = z.object({
  id: common.objectId,
  name: z.string().nullable(), // null: 4 (0.00%)
  next: common.objectId.nullable(),
  exits_canvas: z.boolean().nullable(), // null: 421 (0.05%)
  audience_description_hash: audienceDescriptionHashSchema,
  exclusion_filters: exclusionFiltersGetSchema,
  filters: filtersGetSchema,
  segments_data_array: z.array(sparseSegmentSchema),
  should_show_read_only_sentences: z.literal(false),
  using_v2_filters: z.boolean().nullable().optional(),
});

export const audiencePathsStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("AUDIENCE_PATHS"),
  step_data: z.object({
    decision_splits: z.array(audiencePathGetSchema),
    everyone_else_exits_canvas: z.boolean().nullable(), // null: 381 (0.11%)
  }),
});
